import { render, staticRenderFns } from "./ProgrammeManagement.vue?vue&type=template&id=f5406a30"
import script from "./ProgrammeManagement.vue?vue&type=script&lang=js"
export * from "./ProgrammeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports